import classNames from 'classnames/bind';
import React from 'react';

import { range } from 'common';


export default
class Paginate extends React.Component {

  onPageChange = (ev) => {
    const page = parseInt(ev.target.getAttribute('data-page'));
    this.props.onPageChange(page);
  }

  onPageNavigate = (ev, disable) => {
    if (disable)
      return;

    const page = this.props.page - 1;
    const motion = ev.target.getAttribute('data-motion');

    switch (motion) {
      case 'first':
        this.props.onPageChange(0);
        break;

      case 'prev':
        this.props.onPageChange(page - 1);
        break;

      case 'next':
        this.props.onPageChange(page + 1);
        break;

      case 'last':
        this.props.onPageChange(this.props.numberOfPages - 1);
        break;
    }
  }

  render() {
    const currentPage = this.props.page;
    const numberOfPages = this.props.numberOfPages;
    const isFirstPage = this.props.page == 1;
    const isLastPage = this.props.page == this.props.numberOfPages;

    return (
      <ul className="pagination">
        <li><PageNavButton motion="first" onClick={this.onPageNavigate} disable={isFirstPage}>&lt;&lt;</PageNavButton></li>
        <li><PageNavButton motion="prev" onClick={this.onPageNavigate} disable={isFirstPage}>&lt;</PageNavButton></li>

        {range(1, numberOfPages + 1, 1).map((i, index) => (
          <li key={index} className={classNames({current: i==currentPage})}>
            <PageButton page={index} title={i} onClick={this.onPageChange} />
          </li>
        ))}

        <li><PageNavButton motion="next" onClick={this.onPageNavigate} disable={isLastPage}>&gt;</PageNavButton></li>
        <li><PageNavButton motion="last" onClick={this.onPageNavigate} disable={isLastPage}>&gt;&gt;</PageNavButton></li>
      </ul>
    );
  }
};

const PageButton = ({title, page, onClick}) =>
  (<a className="is-clickable" data-page={page} onClick={onClick}>{title}</a>)

const PageNavButton = ({motion, disable, onClick, children}) =>
  (<a onClick={(ev) => onClick(ev, disable)} data-motion={motion} className={classNames('is-clickable', {'btn--disabled': disable})}>{children}</a>)
